module.exports = __webpack_public_path__ + "static/img/fx2-guitar-match.6dac501.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/fx2-guitar-match.jpg
// module id = 7Dkl
// module chunks = 12